import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const DesignersCreate = props => (
  <Create {...props} resource="designers">
    <Form />
  </Create>
);

DesignersCreate.propTypes = {};

export default DesignersCreate;
